<template>
  <div class="container-component-main">
    <section v-if="!isPreview" class="container-component-header">
      <div class="title" @click="home()">
        <i class="icon icon-econ"></i>
        <p>Ericsson Radio System Interactive Presentation</p>
      </div>
      <div class="buttons-container">
        <a class="btn" @click="admin" v-if="isAdmin && isWeb">
          Admin page
        </a>
        <a v-if="isWeb" class="btn" href="mailto:michail.papadopoulos@ericsson.com">
          Feedback
        </a>
        <i
          ref="expand"
          class="icon icon-maximize"
          @click="toggleFullscreen()"
        ></i>
      </div>
    </section>
    <slot></slot>
  </div>
</template>

<script>
import { authService } from '@/services/security';
import { ROLES } from '@/constants/roles';

export default {
  name: 'ContainerComponent',
  data() {
    return {
      iconMax: 'icon-maximize',
      iconMin: 'icon-minimize',
      isAdmin: false
    };
  },
  props: {
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  
  computed: {
    isWeb() {
      return !(localStorage.getItem('isElectron') || false);
    }
  },
  async created() {
    this.isAdmin = await authService.hasPermission(ROLES.ADMIN);
  },
  methods: {
    home() {
      this.$router.push({ name: 'radio' });
    },
    admin() {
      this.$router.push({ name: 'admin' })
    },
    toggleFullscreen() {
      // browser is fullscreen
      this.setIcon();
      if (window.innerHeight == screen.height) {
        this.closeFullscreen();
      } else {
        this.openFullscreen();
      }
    },
    setIcon() {
      if (this.$refs.expand.classList.contains(this.iconMax)) {
        this.$refs.expand.classList.remove(this.iconMax);
        this.$refs.expand.classList.add(this.iconMin);
      } else if (this.$refs.expand.classList.contains(this.iconMin)) {
        this.$refs.expand.classList.remove(this.iconMin);
        this.$refs.expand.classList.add(this.iconMax);
      }
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },
    openFullscreen() {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        /* Safari */
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        /* IE11 */
        document.documentElement.msRequestFullscreen();
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.container-component-main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.container-component-header {
  display: flex;
  justify-content: space-between;
  background-color: @layer0;
  align-items: center;
  min-height: @appbar-height;
  padding: 0 @space-large;
  padding-right: 60px + @space-large;
  .title {
    cursor: pointer;
  }
  .buttons-container {
    .btn {
      margin-right: 16px;
    }
  }
  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    p {
      margin-left: @space-base;
      color: @white;
      font-size: @font-size;
      font-weight: 500;
    }
  }
  .icon-econ {
    font-size: 21 / @px;
  }
  .icon-maximize {
    font-size: 14 / @px;
    cursor: pointer;
  }
  .icon-maximize {
    font-size: 14 / @px;
    cursor: pointer;
  }
  .icon-minimize {
    font-size: 14 / @px;
    cursor: pointer;
  }
}
</style>
